import React, { useState, useEffect } from "react";
import { Typography, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getInvoiceByIdAndInvoiceNumber } from "../../../api/invoiceService";

const InvoiceDisplay = ({ id, invoiceNumber }) => {
  const { t } = useTranslation("common");
  const [data, setData] = useState(null);
  const [message, setMessage] = useState(t("invoice.public.messages.wait"));
  const [logoImgSrc, setLogoImgSrc] = useState("");

  const baseApiUrl = process.env.REACT_APP_API_URL;
  const publicUploadsFolder = "public_uploads";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getInvoiceByIdAndInvoiceNumber(id, invoiceNumber);
        setData(data);
        const bustCache = Date.now();
        setLogoImgSrc(`${baseApiUrl}/${publicUploadsFolder}/logo-${data.office.id}.png?${bustCache}`);
      } catch (error) {
        setMessage("Invoice not found");
      }
    };
    fetchData();
  }, [id, invoiceNumber]);

  if (!data) {
    return (
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "1rem" }}>
        {message}
      </Typography>
    );
  }

  return (
    <div id="print-section">
      <Box 
        component="img" 
        src={logoImgSrc} 
        alt="logo" 
        sx={{ maxHeight: 80, display: "block" }} 
        onError={(e) => {
          e.currentTarget.src = "/images/logo-0.png";
        }}
      />
      <Typography variant="body2">{data.office.name}</Typography>
      <Typography variant="body2">{data.office.address}</Typography>
      <Typography variant="body2">{`tel. no. ${data.office.contact_number} e-mail ${data.office.email}`}</Typography>
      <br />
      <Typography variant="h4" sx={{ mt: 2 }}>INVOICE</Typography>
      <Typography variant="body1">{`Invoice #: ${data.invoice_number}`}</Typography>
      <Typography variant="body1">{`Date: ${data.date}`}</Typography>
      <Typography variant="body1">
        {data.due_date ? `Due Date: ${data.due_date}` : "Due Date: (not specified)"}
      </Typography>
      <br />
      <Typography variant="h6">Bill To</Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        {`${data.owner.first_name} ${data.owner.last_name}`}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>{data.owner.email}</Typography>
      <br />
      <Typography variant="h6">For Pet</Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        {`${data.pet.name}`}
      </Typography>
      <br />
      <TableContainer
        component={Paper}
        elevation={0}                 
        sx={{
          width: 700,
          // maxWidth: '100%',
          overflowX: 'visible',
          boxShadow: 'none',
        }}
      >
        <Table sx={{ minWidth: 200 }} aria-label="invoice table">
          <TableHead>
            <TableRow sx={{ borderBottom: "2px solid lightgray" }}>
              <TableCell align="left"><b>Qty</b></TableCell>
              <TableCell align="left"><b>Item Description</b></TableCell>
              <TableCell align="right"><b>Unit Price</b></TableCell>
              <TableCell align="right"><b>Amount</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.items?.map((item) => (
              <TableRow key={item.id} sx={{ borderBottom: "none" }}>
                <TableCell align="left">{item.quantity}</TableCell>
                <TableCell align="left">{item.name}</TableCell>
                <TableCell align="right">{item.unit_price}</TableCell>
                <TableCell align="right">{item.line_total}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell />
              <TableCell align="right" sx={{ fontWeight: "bold" }}>Total</TableCell>
              <TableCell />
              <TableCell align="right" sx={{ fontWeight: "bold" }}>{data.total_amount}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default InvoiceDisplay;
